import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=6aefe188"
import script from "./FormGroup.vue?vue&type=script&lang=ts"
export * from "./FormGroup.vue?vue&type=script&lang=ts"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=6aefe188&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports